import { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
import {
  FOLLOW_UP_DUE_BADGE_STYLES,
  getFollowUpDueBadgeLabel,
  getFollowUpDueUrgency,
} from '../../lib/crm/followUpDueBadge';

interface CrmFollowUpDueBadgeProps {
  nextFollowUpAt?: string | null;
  className?: string;
}

export default function CrmFollowUpDueBadge({
  nextFollowUpAt,
  className = '',
}: CrmFollowUpDueBadgeProps) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    if (!nextFollowUpAt) return;
    setNow(new Date());
    const timer = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(timer);
  }, [nextFollowUpAt]);

  if (!nextFollowUpAt) return null;

  const urgency = getFollowUpDueUrgency(nextFollowUpAt, now);
  if (!urgency) return null;

  const label = getFollowUpDueBadgeLabel(nextFollowUpAt, now);
  if (!label) return null;

  return (
    <span
      className={`inline-flex max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold ring-1 ring-inset ${FOLLOW_UP_DUE_BADGE_STYLES[urgency]} ${className}`}
      title={label}
    >
      <Clock className="h-2.5 w-2.5 shrink-0" aria-hidden />
      <span className="truncate">{label}</span>
    </span>
  );
}
